/**
 * WordPress dependencies
 */
export * from '@wordpress/date';
